import {Yii} from "libraries/interfaces/Yii";

// Angular
import {Injectable} from '@angular/core';
import {LabelService} from "libraries/service/label/label.service";

interface IFlexibilityOptions {
    value: number;
    label: string;
}

interface IFlexibilityDates {
    value: number;
    label: string;
}

@Injectable()
export class FlexibilityService {

    constructor(private labelService: LabelService) {
    }

    public getFlexibilityOptions(flexibilities: number): IFlexibilityOptions[] {
        const flexibilitiesList: IFlexibilityOptions[] = [{
            value: 0,
            label: Yii.t('wui-shared-js', "Aucune flexibilité")
        }];

        for (let i: number = 1; i <= flexibilities; i++) {
            let label: string;

            if (i === 1) {
                label  = this.labelService.completeLabel(
                    Yii.t('wui-shared-js', 'Propositions à +/- 1 jour'),
                    String(i)
                );
            } else {
                label = this.labelService.completeLabel(
                    Yii.t('wui-shared-js', 'Propositions à +/- %placeholder% jours'),
                    String(i)
                );
            }

            flexibilitiesList.push({
                value: i,
                label,
            });
        }

        return flexibilitiesList;
    }
}